import { EmptyDocument } from "asset/icons";

const FinanceEmptyState = ({ type, text = "You haven’t uploaded any documents" }) => (
    <div className="min-h-[230px] flex flex-col items-center justify-center w-full">
        <EmptyDocument />
        {type ? (
            <p className="text-center">You dont have any {type.toLowerCase()} finance</p>
        ) : (
            <p className="text-center">{text}</p>
        )}
    </div>
);


export default FinanceEmptyState